import React from "react";
import styles from "./Training.module.css";

const Training = () => {
  const details = [
    { label: "Field Assistance Available For Channel Partner", value: "YES" },
    { label: "Channel Partner Training programme", value: "YES" },
    { label: "Detailed Operating Manuals For Channel Partner", value: "YES" },
    { label: "Assistance From Head Office To Channel Partner", value: "YES" },
    { label: "Have standard Channel Partner Agreement", value: "YES" },
  ];

  return (
    <section className={styles.training}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Channel Partner Training Details</h2>
        <div className={styles.grid}>
          {details.map((detail, index) => (
            <div
              key={index}
              className={styles.detail}
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <h3>{detail.label}</h3>
              <p>{detail.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Training;
